import './DacLoginForm.css';
import React, { useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { validateRequired, runValidations, validatePassword, validateRequiredCheckbox, validateAlphaNumericUsername, validateMaxLength, validateMinLength } from '../../Login/commomFunctions';
import FormField from '../../Login/components/FormField';
import Password from '../../Login/components/Password';
import Checkboxes from '../../Login/components/Checkboxes';
import InjectHTML from './InjectHTML';
import { getSessionId } from '../../DAcApplication/utils';
import Loader from '../../DAcApplication/components/loader';
import RouterLink from '../../atoms/RouterLink/RouterLink';
import { getDictionaryItem, get, canUseDOM } from '../../../utils';
import Modal from './Modal';
import AuthInvitationCode from './InvitationCode/AuthInvitationCode';
const DacLoginForm = _ref => {
  let {
    dictionary,
    configuration,
    isLoginComponent = false,
    apiConfig,
    fieldsParams
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const sessionId = getSessionId('register');
  const usernameMaxLength = fieldsParams && fieldsParams.usernameMaxLength ? fieldsParams.usernameMaxLength : 20;
  const usernameMinLength = fieldsParams && fieldsParams.usernameMinLength ? fieldsParams.usernameMinLength : 3;
  const [username, setUsername] = useState('');
  const [errorUsername, setErrorUsername] = useState('');
  const usernameFieldProps = {
    value: username,
    fieldError: errorUsername,
    setError: setErrorUsername,
    label: getDictionaryItem(dictionary, 'username'),
    type: 'text',
    id: 'LoginUsername',
    name: 'LoginUsername',
    placeholder: '',
    labelLight: false,
    errorRequired: getDictionaryItem(dictionary, 'usernameRequired') || ' ',
    autoComplete: 'username',
    required: true,
    requiredFromContent: true,
    maxLength: usernameMaxLength,
    errorMaxLength: getDictionaryItem(dictionary, 'usernameMaxLengthError') || ' ',
    minLength: usernameMinLength,
    errorMinLength: getDictionaryItem(dictionary, 'usernameMinLengthError') || ' ',
    errorValue: getDictionaryItem(dictionary, 'usernameInvalid') || ' ',
    changeEvent: value => {
      setUsername(value);
    },
    blurEvent: value => {
      usernameFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : username;
      return runValidations([validateRequired, validateMaxLength, validateMinLength, validateAlphaNumericUsername], value, usernameFieldProps);
    }
  };
  const [password, setPassword] = useState('');
  const [errorPassword, setErrorPassword] = useState('');
  const passwordFieldProps = {
    value: password,
    fieldError: errorPassword,
    setError: setErrorPassword,
    label: getDictionaryItem(dictionary, 'password'),
    type: 'password',
    id: 'LoginPassword',
    name: 'LoginPassword',
    placeholder: '',
    labelLight: false,
    passLink: null,
    errorRequired: getDictionaryItem(dictionary, 'passwordRequired') || ' ',
    errorValue: getDictionaryItem(dictionary, 'passwordIsNotValid') || ' ',
    autoComplete: 'current-password',
    required: true,
    requiredFromContent: true,
    changeEvent: value => {
      setPassword(value);
    },
    blurEvent: value => {
      passwordFieldProps.validate(value);
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : password;
      return runValidations([validateRequired, validatePassword], value, passwordFieldProps);
    }
  };
  const [checkboxes, setCheckboxes] = useState([
  // {
  //   name: 'LoginEmailMarketing',
  //   id: 'LoginEmailMarketing',
  //   value: false,
  //   label: get(configuration, 'acceptEmailOrMessagesText.jss.value'),
  //   required: false,
  // },
  {
    name: 'LoginPrivacyPolicy',
    id: 'LoginPrivacyPolicy',
    value: false,
    label: get(configuration, 'acceptDGDPRAndPrivacyPolicyText.jss.value'),
    childrenHTML: /*#__PURE__*/React.createElement(InjectHTML, {
      htmlString: get(configuration, `acceptDGDPRAndPrivacyPolicyText.jss.value`)
    }),
    required: true
    //   errorRequired: errorRequiredPrivacyPolicy,
  }]);
  const [errorCheckboxes, setErrorCheckboxes] = useState('');
  const checkboxesFieldProps = {
    checkboxes: checkboxes,
    fieldError: errorCheckboxes,
    setError: setErrorCheckboxes,
    errorRequired: '',
    changeEvent: (name, value) => {
      let checkboxesCopy = checkboxes;
      checkboxesCopy = checkboxesCopy.filter(item => {
        if (item.name === name) {
          item.value = value;
        }
        return item;
      });
      setCheckboxes(checkboxesCopy);
      checkboxesFieldProps.validate();
      //   formFillAnalytics();
    },
    validate: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : checkboxes;
      return runValidations([validateRequiredCheckbox], value, checkboxesFieldProps);
    }
  };
  useEffect(() => {
    if (username && !errorUsername && password && !errorPassword && checkboxes.filter(item => item.required).every(item => item.value) && !errorCheckboxes) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
    setAuthFailed('');
  }, [username, password, checkboxes, errorUsername, errorPassword, errorCheckboxes]);
  const urlRedirect = get(configuration, 'loginButton.jss.value.href');
  const formSubmit = event => {
    event.preventDefault();
    authorizeUser();
  };
  const [submitLoader, setSubmitLoader] = useState(0);
  const [authFailed, setAuthFailed] = useState('');
  const [tokenResult, setTokenResult] = useState({});
  const authorizeUser = async () => {
    setSubmitLoader(prev => prev + 1);
    setAuthFailed('');
    const url = `${apiConfig.apiUrl}/v1/proxy/individual/authenticate`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiConfig.apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Methods', 'GET,HEAD,POST,OPTIONS');
    headers.append('Access-Control-Allow-Origin', '*');
    const data = {
      username: username,
      password: password
    };
    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data)
    };
    await fetch(url, requestOptions).then(response => response.json()).then(result => {
      if (result.hasOwnProperty('desc')) {
        setAuthFailed(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('access_token')) {
        setTokenResult(result);
        // call next step for submitting invitation code
        // getUserStatus(); //run in useEffect
      }
    }).catch(error => {
      console.error('authorizeUser error', error);
      setAuthFailed(error.message);
    }).finally(() => setSubmitLoader(prev => prev - 1));
  };
  useEffect(() => {
    if (tokenResult.access_token) {
      getUserStatus();
    }
  }, [tokenResult]);
  const getUserStatus = async () => {
    setSubmitLoader(prev => prev + 1);
    const url = `${apiConfig.apiUrl}/v1/orc/user/${username}/status`;
    const headers = new Headers();
    headers.append('X-Request-Id', sessionId);
    headers.append('Apikey', apiConfig.apiKey);
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${tokenResult.access_token}`);
    headers.append('Host', 'dacqa.detsandbox.com');
    headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
      keepalive: true,
      withCredentials: true
    };
    await fetch(url, requestOptions).then(response => {
      if (response.status == 401) {}
      return response.json();
    }).then(result => {
      if (result.hasOwnProperty('desc')) {
        setAuthFailed(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
        console.error(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
      }
      if (result.hasOwnProperty('status')) {
        if (result.status === false) {
          setShowModal(true);
        } else {
          callAfterSubmit();
        }
      }
    }).catch(error => {
      setAuthFailed(error.message);
      console.error('User Status error', error);
    }).finally(() => setSubmitLoader(prev => prev - 1));
  };
  const redirectToUrl = pathToRedirect => {
    if (canUseDOM) {
      window.location.href = pathToRedirect;
    }
  };
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (showModal) {
      document.body.classList.add('prevent-scroll');
    } else {
      document.body.classList.remove('prevent-scroll');
    }
    return () => {
      document.body.classList.remove('prevent-scroll');
    };
  }, [showModal]);
  const insertCookies = () => {
    const expirationDate = new Date(tokenResult.expires_on).getTime();
    const currentDate = new Date().getTime();
    const daysUntilExpiration = Math.round((expirationDate - currentDate) / (1000 * 3600 * 24));
    Cookies.set('token', `Bearer ${tokenResult.access_token}`, {
      expires: daysUntilExpiration,
      secure: true
    });
    Cookies.set('username', username, {
      expires: daysUntilExpiration,
      secure: true
    });
  };
  const callAfterSubmit = () => {
    insertCookies();
    redirectToUrl(urlRedirect);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("form", {
    className: "dac-login-form",
    onSubmit: event => formSubmit(event)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorUsername ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(FormField, usernameFieldProps))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap ${errorPassword ? 'invalid-field' : ''}`
  }, /*#__PURE__*/React.createElement(Password, passwordFieldProps)))), /*#__PURE__*/React.createElement("p", {
    className: "dac-login-form__forgot"
  }, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: get(configuration, `forgotText.jss.value`)
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-elements dac-login-form__checkboxes"
  }, /*#__PURE__*/React.createElement(Checkboxes, checkboxesFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "dac-login-form__submit-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit",
    type: "submit",
    disabled: disableSubmit || Boolean(submitLoader)
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: Boolean(submitLoader) ? 0 : 1
    }
  }, get(configuration, 'loginButton.jss.value.text')), Boolean(submitLoader) ? /*#__PURE__*/React.createElement(Loader, null) : false), authFailed && /*#__PURE__*/React.createElement("b", {
    className: "dac-login-form__error"
  }, authFailed)), isLoginComponent && /*#__PURE__*/React.createElement("div", {
    className: "dac-login-form__register"
  }, /*#__PURE__*/React.createElement("b", null, "Don\u2019t have an account?", ' ', /*#__PURE__*/React.createElement(RouterLink, {
    className: '',
    href: '#'
  }, 'Create one to Apply')))), showModal && /*#__PURE__*/React.createElement(Modal, {
    hide: () => setShowModal(false),
    dictionary: dictionary,
    rtl: rtl,
    title: get(configuration, 'invitationSectionTitle.jss.value'),
    description: get(configuration, 'invitationSectionDescription.jss.value'),
    children: /*#__PURE__*/React.createElement(AuthInvitationCode, {
      dictionary: dictionary,
      configuration: configuration,
      apiConfig: apiConfig,
      sessionId: sessionId,
      hide: () => setShowModal(false),
      callAfterSubmit: callAfterSubmit,
      rtl: rtl,
      username: username
    })
  }));
};
export default DacLoginForm;
const commonStyles = "c1g5msba";
const ltrStyles = "l1ebb8uv";
const rtlStyles = "r189k0v3";